import { IonButtons, IonContent, IonButton, IonHeader, IonLabel, IonToolbar, IonIcon, IonThumbnail, IonItem, IonText, IonCard, IonNote } from "@ionic/react";
import { closeOutline, openOutline } from "ionicons/icons";
import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import './RefundDetailsPage.css';
import moment from "moment";
import { Asset, DisplayableOperation } from "../../types/types";
import AppHeader from "../../components/AppHeader/AppHeader";
import * as stellarUtils from '../../services/stellar/stellar-utils';
import { Browser } from "@capacitor/browser";
import { capitalizeFirstLetter } from "../../services/utils/capitalizeFirst";
import { App, BackButtonListenerEvent } from '@capacitor/app';

type MyModalProps = {

    operation: any;
    closeAction: Function;
    asset: Asset
}

const RefundDetailsPage: React.FC<MyModalProps> = (props) => {

    // dealing with android back button and modals
    // App.addListener('backButton', (ev: BackButtonListenerEvent) => {
    //     props.closeAction()
    // });

    useEffect(() => {
        let backButtonListener:any;
    
        const setupBackButtonListener = async () => {
            backButtonListener = await App.addListener('backButton', (ev: BackButtonListenerEvent) => {
                props.closeAction();
            });
        };
    
        setupBackButtonListener();
    
        // Cleanup function
        return () => {
            backButtonListener?.remove();
        };
    }, [props.closeAction]);

    const { t, i18n } = useTranslation();
    const stellarExperUIURL = `${import.meta.env.VITE_STELLAR_EXPERT_UI_URL}`;

    const goToTransactionExplorer = async (transactionId: string) => {

        await Browser.open({ url: `${stellarExperUIURL}/tx/${transactionId}` });

    }

    return (

        <>

            <IonHeader className="ion-no-border">
                <IonToolbar >
                    <IonButtons slot="start">
                        <IonButton onClick={() => { props.closeAction() }}>
                            <IonIcon slot="icon-only" icon={closeOutline} color="danger" />
                        </IonButton>
                    </IonButtons>
                    {/* <IonButtons slot="primary">
                        <IonButton onClick={() => { goToTransactionExplorer(props.operation.transactionId) }}>
                            <IonIcon slot="icon-only" icon={openOutline} color="danger" />
                        </IonButton>
                    </IonButtons> */}

                </IonToolbar>
            </IonHeader>

            <AppHeader
                title={(props.operation.isRecipient ? '+' : '-') + `${parseFloat(props.operation.amount.toString()).toFixed(props.asset.decimal_places)} ${props.operation.token.code}`}>
            </AppHeader>

            <IonContent>

                <IonItem lines='none'>
                    <IonLabel slot='start'>
                        <IonText className="ion-text-wrap">
                            {
                               
                                (props.operation.isRecipient) ?
                                    (
                                        <h5>
                                            {capitalizeFirstLetter(t('payment.details.received') as string)}
                                        </h5>
                                    ) :
                                    (
                                        <h5>
                                            {capitalizeFirstLetter(t('payment.details.sent') as string)}
                                        </h5>
                                    )

                            }

                        </IonText>
                        <IonNote className="tradeDetailsPage_IonNote">
                            {moment.unix(props.operation.timestamp).format("D MMM YYYY,h:mm")}
                        </IonNote>
                    </IonLabel>
                    <IonThumbnail className="refundDetails_Thumbnail" slot="end">
                        <img src={props.asset.icon} />
                    </IonThumbnail>
                </IonItem>

                <IonCard>
                    <IonItem lines='none' >
                        <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                            {t('trade.details.status')}
                        </IonNote>
                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>
                            {t('trade.details.status-LABEL-COMPLETED')}
                        </IonNote>
                    </IonItem>

                    {/* <IonItem lines='none' >
                        {
                            props.operation.isRecipient ?
                                <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                                    {t('payment.details.from')}
                                </IonNote>
                                :

                                <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                                    {t('payment.details.to')}
                                </IonNote>
                        }

                        {
                            props.operation.name ?
                                (
                                    <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>
                                        {capitalizeFirstLetter(props.operation.name)}
                                    </IonNote>
                                ) :

                                (
                                    <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>
                                        {stellarUtils.shortenAccountId(props.operation.otherAccount.publicKey)}
                                    </IonNote>
                                )
                        }

                    </IonItem> */}

                    <IonItem lines='none' >

                        <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                            {t('payment.details.amount')}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>
                            {parseFloat(props.operation.amount.toString()).toFixed(props.asset.decimal_places)} {props.asset.display_code}
                        </IonNote>
                    </IonItem>


                    <IonItem lines='none' hidden={!props.operation.memo} >

                        <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                            {'Memo'}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>
                            {props.operation.memo}
                        </IonNote>
                    </IonItem>

                    <IonItem lines='none' hidden={!props.operation.description}>

                        <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                            {t('payment.details.description')}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>
                            {props.operation.description}
                        </IonNote>
                    </IonItem>

                    <IonItem lines='none'>

                        <IonNote slot='start' className='tradeDetailsPage_IonNote'>
                            {t('payment.details.refund.transaction')}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='dark'>
                            {`${props.operation.info.external_transaction_id}`}
                        </IonNote>
                    </IonItem>

                </IonCard>

            </IonContent>

        </>

    )
}

export default RefundDetailsPage